import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SurveyEditPage } from '@/features/surveys/pages/SurveyEditPage';

export const Route = createFileRoute('/_auth/feedback/surveys/$surveyId/edit')({
  parseParams: ({ surveyId }) => {
    const parsedId = Number(surveyId);
    if (!Number.isInteger(parsedId) || parsedId <= 0) throw notFound();
    return { surveyId: parsedId };
  },
  component: () => (
    <ErrorBoundary moduleName="Edit Survey">
      <Suspense fallback={<PageLoader />}>
        <SurveyEditPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
